import { EventSourceHandler } from '@sellsy/sse';

export default class ValidationDocumentFinishedEventSourceHandler extends EventSourceHandler {
    constructor(){
        super()
        this.type = 'staff.validation.document'
    }

    handle(event){
        Push.success(i18n.__("Vos documents sont validés"));
    }
}